/*
 * Cursor spotlight (PRD H4/H6; Motion Spec §2). Desktop pointers only.
 * Only CSS variables change — no layout work — eased with rAF (~60 fps).
 * Also drives the small spotlight inside each product card.
 */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches ||
      matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-spotlight], [data-hero]').forEach(el => {
    let x = 0, y = 0, tx = 0, ty = 0, raf = null, primed = false;
    const tick = () => {
      x += (tx - x) * .15; y += (ty - y) * .15;
      el.style.setProperty('--mx', x + 'px'); el.style.setProperty('--my', y + 'px');
      raf = Math.abs(tx - x) + Math.abs(ty - y) > .5 ? requestAnimationFrame(tick) : null;
    };
    el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect();
      tx = e.clientX - r.left; ty = e.clientY - r.top;
      if (!primed) { x = tx; y = ty; primed = true; }   // no sweep-in from the corner
      el.classList.add('is-lit');
      if (!raf) raf = requestAnimationFrame(tick);
    });
    el.addEventListener('pointerleave', () => { el.classList.remove('is-lit'); primed = false; });
  });

  // Card inner spotlight: position only, the card's own hover handles the fade.
  document.addEventListener('pointermove', e => {
    const card = e.target.closest && e.target.closest('.card');
    if (!card) return;
    const r = card.getBoundingClientRect();
    card.style.setProperty('--cx', (e.clientX - r.left) + 'px');
    card.style.setProperty('--cy', (e.clientY - r.top) + 'px');
  }, { passive: true });
})();
